import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";

const styles = () => ({
  formControlLabel: {
    fontSize: "15px",
    color: "#000000",
  },

  error: {
    marginBottom: 10,
    fontSize: 12,
    color: '#F03A47',
  },
});

class AnswerRadio extends React.Component {
  render() {
    const { classes, options, select, checkedValue, error, errorText } = this.props;
    return (
      <React.Fragment>
        <RadioGroup
          className={classes.group}
          value={checkedValue.toString()}
          onChange={(event) => select(event.target.value)}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value.toString()}
              control={<Radio color="primary" />}
              label={option.text}
              classes={{ label: classes.formControlLabel }}
            />
          ))}
        </RadioGroup>
        {error && (
          <Typography variant="subheading" className={classes.error}>{errorText}</Typography>
        )}
      </React.Fragment>
    )
  }
}

AnswerRadio.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  select: PropTypes.func.isRequired,
  checkedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.string,
};

export default withStyles(styles)(AnswerRadio);



// WEBPACK FOOTER //
// ./src/components/Questionnaire/parts/AnswerRadio.jsx